import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function AnimatedStatsSection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Animate stroke from empty (283) to 60% filled (100) faster
  const strokeDashoffset = useTransform(scrollYProgress, [0.15, 0.5], [283, 100]);
  // Fade in text during scroll
  const textOpacity = useTransform(scrollYProgress, [0.25, 0.4, 0.65, 0.8], [0, 1, 1, 0]);
  return <section ref={ref} className="h-[100vh] relative overflow-hidden -mt-64" data-id="element-1">
      <div className="sticky top-0 h-screen flex items-center justify-center" data-id="element-2">
        <div className="relative w-[500px] h-[500px] md:w-[600px] md:h-[600px] flex items-center justify-center" data-id="element-3">
          {/* Circular Progress Graphic */}
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100" overflow="visible" data-id="element-4">
            {/* Background Circle */}
            <circle cx="50" cy="50" r="45" fill="none" stroke="#ffffff" strokeOpacity="0.1" strokeWidth="6" data-id="element-5" />
            {/* Animated Green Circle */}
            <motion.circle cx="50" cy="50" r="45" fill="none" stroke="#a1da52" strokeWidth="6" strokeDasharray="283" strokeLinecap="butt" className="drop-shadow-[0_0_15px_rgba(161,218,82,0.5)]" style={{
            strokeDashoffset
          }} data-id="element-6" />
          </svg>

          {/* Text Content */}
          <motion.div style={{
          opacity: textOpacity
        }} className="absolute inset-0 flex flex-col items-center justify-center text-center p-12" data-id="element-7">
            <span className="text-7xl md:text-9xl font-bold text-white tracking-tighter mb-6" data-id="element-8">
              &gt;60%
            </span>
            <p className="text-lg md:text-2xl text-[#BFE0FF] max-w-[320px] leading-relaxed" data-id="element-9">
              Biobanks still running core operations on fragmented LIMS and
              spreadsheets
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}